"use strict";
var appn;
(function (appn) {
    var taskTemplateFilter;
    (function (taskTemplateFilter) {
        function init() {
            let value = getStateOrDefault().value;
            const templateIdFromUrl = appn.utils.getUrlParamByName('template');
            if (templateIdFromUrl)
                value = templateIdFromUrl;
            setValue(value);
            addEvents();
        }
        taskTemplateFilter.init = init;
        function addEvents() {
            $('.appnTaskTemplateFilter .appnTaskTemplateFilter-link').off().on('click', function (e) {
                e.preventDefault();
                setValue($(this).prop('id'));
            });
        }
        function getStateOrDefault() {
            const appnTaskTemplateFilter = $('.appnTaskTemplateFilter');
            return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnTaskTemplateFilter), getValue());
        }
        taskTemplateFilter.getStateOrDefault = getStateOrDefault;
        function getValue() {
            const appnTaskTemplateFilter = $('.appnTaskTemplateFilter');
            const value = appnTaskTemplateFilter.find('li.active .appnTaskTemplateFilter-link').prop('id');
            if (value === 'appnTaskTemplateFilter-all')
                return appn.emptyString;
            return value;
        }
        taskTemplateFilter.getValue = getValue;
        function setValue(value) {
            appn.dataTable.uncheckAllRowsBox();
            if (getValue() === value)
                return;
            const appnTaskTemplateFilter = $('.appnTaskTemplateFilter');
            appnTaskTemplateFilter.find('li').removeClass('active');
            appnTaskTemplateFilter.find('#' + (!value ? 'appnTaskTemplateFilter-all' : value)).closest('li').addClass('active');
        }
        taskTemplateFilter.setValue = setValue;
        function reset() {
            setValue();
        }
        taskTemplateFilter.reset = reset;
        function listContains(value) {
            let exists = false;
            const templates = $('.appnTaskTemplateFilter .appnTaskTemplateFilter-link');
            $(templates).each(function () {
                if ((this).id === 'appnTaskTemplateFilter-all')
                    return true;
                if ((this).id === value) {
                    exists = true;
                    return false;
                }
                return true;
            });
            return exists;
        }
        taskTemplateFilter.listContains = listContains;
    })(taskTemplateFilter = appn.taskTemplateFilter || (appn.taskTemplateFilter = {}));
})(appn || (appn = {}));
